import React from 'react';
import { FormState, Form as FormStateForm } from 'react-formstate';
import classNames from 'classnames';
import WiredInput from '../components/WiredInput';
import { focusOnFirstInvalid, populateFormErrors } from '../../utils/validation';
import ValidationMessage from '../components/ValidationMessage';
import forceRerenderParent from '../components/forceRerenderParent';
import LanguageSwitcher from '../components/LanguageSwitcher';

class Form extends React.Component {
  formState = FormState.create(this);
  state = {};

  onInputChange = ({ target: { name, value } }) => {
    const context = this.formState.createUnitOfWork(); // this is so java
    context.set(name, value).validate();
    context.updateFormState();
  };

  onSubmit = (e) => {
    const { onSubmit } = this.props;
    e.preventDefault();

    const model = this.formState.createUnitOfWork().createModel();
    if (model) {
      onSubmit(e, model);
    } else {
      focusOnFirstInvalid(this.formState, this);
    }
  };

  render() {
    const { formDisabled, onCancel, langSwitcher, wasSent } = this.props;
    const errors = populateFormErrors(this.formState);

    return (
      <section className="login">
        <div className="c-floating">
          <div className="c-inactive-bg__stop">
            {(langSwitcher || onCancel) &&
            <div className="c-floating__head">
              {onCancel
                ? <span className="u-link text-icon" onClick={onCancel}>
                    <i className="icon-arrow-back text-icon__icon" />
                    <span className="text-icon__text">Naspäť</span>
                  </span>
                : <span />
              }
              {langSwitcher ? <LanguageSwitcher /> : <span />}
            </div>
            }
            <FormStateForm formState={this.formState} className="c-floating__body" onSubmit={this.onSubmit}>
              <fieldset disabled={formDisabled}>
                <h1 className="new-campaign__header">Zabudli ste heslo?</h1>

                {wasSent
                  ? <div>
                      <p className="c-para">
                        <strong>
                          Na váš email sme zaslali inštrukciu pre obnovenie hesla. V prípade pretrvávajúcich problémov nás kontaktujte na&nbsp;<a href="mailto:info@darujme.sk" className="u-underline">info@darujme.sk</a>.
                        </strong>
                      </p>

                      <a href="/p2p/prihlasenie/" type="submit" className="c-button c-button--primary new-campaign__button">
                        <span className="c-button__content">
                          <span className="text-icon">
                            <span className="text-icon__text">Prihlásenie</span>
                            <i className="icon-arrow-forward text-icon__icon"/>
                          </span>
                        </span>
                      </a>
                    </div>
                  : <div>
                      <p className="c-para">
                        Pre obnovu hesla, zadajte emailovú adresu, s ktorou ste sa registrovali. Ak ste adresu zabudli, kontaktujte nás na&nbsp;<a href="mailto:info@darujme.sk" className="u-underline">info@darujme.sk</a>.
                      </p>

                      <label className="c-input__wrapper">
                        <span className="c-input__label">E-mailová adresa</span>
                        <span className={classNames(
                          'c-input__border', 'new-campaign__input-text',
                          { 'c-input__border--error': errors.email }
                        )}>
                          <WiredInput
                            name="email"
                            className="c-input"
                            onChange={this.onInputChange}
                            autoFocus
                            validator={v => v
                              .email().msg('passwordReset.form.errors.email.email')
                              .required().msg('passwordReset.form.errors.email.required')}
                          />
                        </span>
                        <ValidationMessage msg={errors.email} />
                      </label>

                      <button type="submit" className="c-button c-button--primary new-campaign__button">
                        <span className="c-button__content">
                          <span className="text-icon">
                            <span className="text-icon__text">Odoslať</span>
                            <i className="icon-arrow-forward text-icon__icon"/>
                          </span>
                        </span>
                      </button>
                    </div>
                }
              </fieldset>
            </FormStateForm>
          </div>
        </div>
      </section>
    );
  }
}

export default forceRerenderParent(Form);



// WEBPACK FOOTER //
// ./app/Assets/js/features/passwordReset/ResetForm.js